import { Instant, InstantSchema } from "@/Temporal"
import { enumSchema, nullableSchema, objectSchema } from "vue-utils"
import { EmergencyPhase } from "./EmergencyPhase"
import type { IIdentifier, Nullable } from "./IncidentEntity"
import { IncidentStatus } from "./IncidentStatus"
import { IncidentType } from "./IncidentType"
import { LatLng } from "./LatLng"
import { UserTimeStamp } from "./UserTimeStamp"

export interface IncidentLogSummary extends IIdentifier {
	identifier: string
	incidentTime: Instant
	status: IncidentStatus
	createdAt: Instant

	reportedIncidentType: IncidentType
	finalIncidentType: Nullable<IncidentType>

	initialEmergencyPhase: EmergencyPhase
	finalEmergencyPhase: Nullable<EmergencyPhase>

	nameOfVesselOrCasualty: Nullable<string>
	personsAtRisk: number
	initialPosition: LatLng

	messageReceived: string
	natureOfIncident: Nullable<string>
	descriptionOfCasualty: Nullable<string>

	signedOff: Nullable<UserTimeStamp>
}

export const IncidentLogSummary = objectSchema<IncidentLogSummary>({
	id: Number,
	identifier: String,
	status: enumSchema(IncidentStatus),
	incidentTime: InstantSchema,
	createdAt: InstantSchema,

	reportedIncidentType: IncidentType,
	finalIncidentType: nullableSchema(IncidentType),

	initialEmergencyPhase: enumSchema(EmergencyPhase),
	finalEmergencyPhase: nullableSchema(enumSchema(EmergencyPhase)),

	nameOfVesselOrCasualty: nullableSchema(String),
	personsAtRisk: Number,
	initialPosition: LatLng,

	messageReceived: String,
	natureOfIncident: nullableSchema(String),
	descriptionOfCasualty: nullableSchema(String),

	signedOff: nullableSchema(UserTimeStamp),
})
